import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

export enum GenericCheckBoxStatus {
  NoneSelected = 1,
  SomeSelected = 2,
  AllSelected = 3,
}

@Component({
  selector: "[generic-check-box-with-minus]",
  template: `
    <input
      (click)="clickHandler($event)"
      [(ngModel)]="_inputValue"
      class="generic-checkbox-input"
      [ngClass]="{
        'some-selected': areSomeSelected
      }"
      type="checkbox"
    />
  `,
  styleUrls: ["./generic-checkbox-with-minus.component.scss"],
})
export class GenericCheckBoxWithMinusComponent {
  @Output() public clickedCheckBox: EventEmitter<GenericCheckBoxStatus> =
    new EventEmitter<GenericCheckBoxStatus>();
  public _inputValue: boolean = false;
  public readonly GenericCheckBoxStatus = GenericCheckBoxStatus;

  constructor(private cdRef: ChangeDetectorRef) {}

  public _selectionStatus: GenericCheckBoxStatus;

  @Input() public set selectionStatus(value: GenericCheckBoxStatus) {
    this._selectionStatus = value;

    setTimeout(() => {
      this._inputValue = value === GenericCheckBoxStatus.AllSelected;
    }, 10);
  }
  public get areSomeSelected(): boolean {
    return this._selectionStatus === GenericCheckBoxStatus.SomeSelected;
  }
  public clickHandler(event: MouseEvent) {
    event.preventDefault();
    let newStatus = GenericCheckBoxStatus.AllSelected;
    switch (this._selectionStatus) {
      case GenericCheckBoxStatus.NoneSelected:
        newStatus = GenericCheckBoxStatus.AllSelected;
        break;
      case GenericCheckBoxStatus.AllSelected:
        newStatus = GenericCheckBoxStatus.NoneSelected;
        break;
      case GenericCheckBoxStatus.SomeSelected:
        newStatus = GenericCheckBoxStatus.NoneSelected;
        break;
    }
    this.clickedCheckBox.emit(newStatus);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/generic-check-box-with-minus/generic-checkbox-with-minus.component.ts